var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.proposals.length > 0
    ? _c(
        "div",
        [
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { hit: "", shadow: "" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("el-switch", {
                    staticStyle: { float: "right", padding: "3px 0" },
                    attrs: {
                      "active-text": "Έμφάνιση",
                      "inactive-text": "Αποκρυψη"
                    },
                    model: {
                      value: _vm.showComments,
                      callback: function($$v) {
                        _vm.showComments = $$v
                      },
                      expression: "showComments"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Εισηγήσεις")])
                ],
                1
              ),
              _vm._v(" "),
              _vm.showComments
                ? _c(
                    "div",
                    { staticClass: "text item" },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.proposals }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Ονοματεπώνυμο", width: "270" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(scope.row.name))])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Ρόλος", width: "200" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.translate(scope.row.role))
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Ημερομηνία", width: "140" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.dateCompleted
                                            ? scope.row.dateCompleted.substring(
                                                0,
                                                16
                                              )
                                            : ""
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Εισήγηση" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          placement: "top-start",
                                          title: "Εισήγηση: "
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { color: "blue" },
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [_vm._v("Πατήστε για άνοιγμα")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              scope.row.proposal
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fabe0e40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fabe0e40","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Proposals.vue
// module id = null
// module chunks = 